import React, {useState, useEffect} from 'react';
import { PrinterOutlined, CloseOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import ShowPatient from './components/showUser';
import ShowLeftEarPain from './components/ChiefComplaints/Ear/showLeftEarPain';
import ShowLeftEarDischarge from './components/ChiefComplaints/Ear/showLeftEarDischarge';
import ShowLeftEarHearingLoss from './components/ChiefComplaints/Ear/showLeftEarHearingloss';
import ShowLeftEarTinnitis from './components/ChiefComplaints/Ear/showLeftEarTinnitis';
import ShowLeftEarVertigo from './components/ChiefComplaints/Ear/showLeftEarVertigo';
import ShowLeftEarFacialWeakness from './components/ChiefComplaints/Ear/showLeftEarFacialWeakness';
import ShowRightEarPain from './components/ChiefComplaints/Ear/showRightEarPain';
import ShowRightEarDischarge from './components/ChiefComplaints/Ear/showRightEarDischarge';
import ShowRightEarHearingLoss from './components/ChiefComplaints/Ear/showRightEarHearingloss';
import ShowRightEarTinnitis from './components/ChiefComplaints/Ear/showRightEarTinnitis';
import ShowRightEarVertigo from './components/ChiefComplaints/Ear/showRightEarVertigo';
import ShowRightEarFacialWeakness from './components/ChiefComplaints/Ear/showRightEarFacialWeakness';

import ShowNasalDischarge from './components/ChiefComplaints/Nasal/showNasalDischarge';
import ShowNasalObstruction from './components/ChiefComplaints/Nasal/showNasalObstruction';
import ShowNasalPain from './components/ChiefComplaints/Nasal/showNasalPain';
import ShowNasalHistoryOfNasalSymptomsWithComplication from './components/ChiefComplaints/Nasal/showNasalHistoryOfNasalSymptomsWithComplication';

import ShowOralCavityPain from './components/ChiefComplaints/OralCavity/showOralCavityPain';
import ShowOralCavityUlcer from './components/ChiefComplaints/OralCavity/showOralCavityUlcer';

import ShowThroatLarynxHypopharynxHoarseness from './components/ChiefComplaints/ThroatLarynxHypopharynx/ShowThroatLarynxHypopharynxHoarseness';
import ShowThroatLarynxHypopharynxBreathingProblem from './components/ChiefComplaints/ThroatLarynxHypopharynx/ShowThroatLarynxHypopharynxBreathingProblem';
import ShowThroatLarynxHypopharynxSwallowingProblem from './components/ChiefComplaints/ThroatLarynxHypopharynx/ShowThroatLarynxHypopharynxSwallowingProblem';

import ShowLeftEar from './components/Examination/Ear/showLeftEar';
import ShowRightEar from './components/Examination/Ear/showRightEar';
import ShowLeftNose from './components/Examination/Nose/showLeftNose';
import ShowRightNose from './components/Examination/Nose/showRightNose';
import ShowOralCavityThroat from './components/Examination/OralCavityThroat/showOralCavityThroat';
import ShowThroatLarynxHypopharynx from './components/Examination/ThroatLarynxHypopharynx/showThroatLarynxHypopharynx';
import ShowThyroid from './components/Examination/Thyroid/showThyroid';
import ShowNeckMass from './components/Examination/NeckMass/showNeckMass';
import ShowParotidSybmandibularMass from './components/Examination/ParotidSybmandibularMass/showParotidSybmandibularMass';
import ShowUlcer from './components/Examination/Ulcer/showUlcer';

import InvestigationShow from './components/InvestigationShow';
import DiagnosisShow from './components/DiagnosisShow';
import TreatmentShow from './components/TreatmentShow';
import { useFirestore } from 'reactfire';
import { Link } from 'react-router-dom';
import Barcode from 'react-barcode';
import {useParams} from 'react-router-dom';

const FinalReport = (props) => {

    let firestore = useFirestore();
    const [chiefComplain, setChiefComplains] = useState({});
    const [examination, setExamination] = useState({});
    const [vitals, setVitals] = useState({});
    const [showWeight, setShowWeight] = useState(false);
    const [showHeight, setShowHeight] = useState(false);
    const [showBloodpressure, setShowBloodpressure] = useState(false);
    const [showOxygenSaturation, setShowOxygenSaturation] = useState(false);
    const [showPulse, setShowPulse] = useState(false);
    const [showBmi, setShowBmi] = useState(false);


    let { id } = useParams();
    
    useEffect( ()=> {
        getChiefComplains();
        getExamination();
        getVitals();
    }, []);

    const getChiefComplains = () => {
        let records = [];
        firestore.collection("ChiefComplaints").where("appointment_id", "==", props.appID).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
            });
        }).finally(() => {
            if(records.length > 0) {
                setChiefComplains(records[0].data);
            }
        });
    }

    const getExamination = () => {
        let records = [];
        firestore.collection("Examination").where("appointment_id", "==", props.appID).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
            });
        }).finally(() => {
            if(records.length > 0) {
                setExamination(records[0].data);
            }
        });
    }

    const getVitals = () => { 
        let records = [];
        console.log('This is something to show up', props.appID);
        
        firestore.collection("vitals_records").where("appointmentId", "==", props.appID).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {

                records.push({data: doc.data(), id: doc.id});
            });

        }).finally(() => {
            if(records.length > 0) {
                console.log(records[0].data, 'records[0].data');
                setVitals(records[0].data);
            }
        });
    }


    const [toShow, setToShow] = useState({
        complainst: props.historyPage ? true : false,
        examination: props.historyPage ? true : false,
        treatment: true,
        diagnosis: true,
        investigation: true,
    });

    const printThis = () => {
        window.focus();
        window.print();
        return true;
    };

    const closeThis = () => {
        props.closeFinalReport();
    };

    const calculateBmi = (weight, height) => {
        if (weight && height) {
            const heightInMeters = height / 100; // Convert height to meters
            return (weight / (heightInMeters ** 2)).toFixed(2); // BMI formula
        }
        return null;
    };

    return (
        <>
        <div className="final_report_wrapper">

            <div className="actionsPnl">
                {props.historyPage && <Link className="attend_inside_history" to={`/attending_patient/${props.patientID}/${props.appID}`}>Attend</Link>}
                <span className=""></span>
                <PrinterOutlined onClick={printThis} />
                {!props.historyPage && <CloseOutlined onClick={closeThis} />}
            </div>

            <ul className="top_switches_wrapper">
                <li>
                    <span>Complaints</span>
                    <Switch defaultChecked={props.historyPage ? true : false} onChange={() => setToShow({...toShow, complainst: !toShow.complainst})} />
                </li>
                <li>
                    <span>Examination</span>
                    <Switch defaultChecked={props.historyPage ? true : false} onChange={() => setToShow({...toShow, examination: !toShow.examination})} />
                </li>
                <li>
                    <span>Treatment</span>
                    <Switch defaultChecked onChange={() => setToShow({...toShow, treatment: !toShow.treatment})} />
                </li>
                <li>
                    <span>Investigation</span>
                    <Switch defaultChecked onChange={() => setToShow({...toShow, investigation: !toShow.investigation})} />
                </li>
                <li>
                    <span>Diagnosis</span>
                    <Switch defaultChecked onChange={() => setToShow({...toShow, diagnosis: !toShow.diagnosis})} />
                </li>
                <li>
                    <span>Vitals</span>
                    <Switch defaultChecked onChange={() => setToShow({...toShow, vitals: !toShow.vitals})} />
                </li>
            </ul>

            <div>
            <div className="barcodePatientShow">
                <Barcode value={id} height={20} width={1} fontSize={12} />
            </div>

            <ShowPatient appDate={props.appDate}/>

            {!toShow.vitals && <ul className='show_vitals'>
                <li><span class={!showWeight ? 'hideInPrint' : ''}>Weight: {vitals.weight} kg</span> <input type="checkbox" onChange={() => setShowWeight(!showWeight)} /></li>
                <li><span class={!showHeight ? 'hideInPrint' : ''}>Height: {vitals.height} cm</span> <input type="checkbox" onChange={() => setShowHeight(!showHeight)} /></li>
                <li><span class={!showBloodpressure ? 'hideInPrint' : ''}>Blood Pressure: {vitals.bloodPressure} mmHg</span> <input type="checkbox" onChange={() => setShowBloodpressure(!showBloodpressure)} /></li>
                <li><span class={!showOxygenSaturation ? 'hideInPrint' : ''}>Oxygen Saturation: {vitals.oxygenSaturation} %</span> <input type="checkbox" onChange={() => setShowOxygenSaturation(!showOxygenSaturation)} /></li>
                <li><span class={!showPulse ? 'hideInPrint' : ''}>Pulse: {vitals.pulse} bpm</span> <input type="checkbox" onChange={() => setShowPulse(!showPulse)} /></li>
                <li><span class={!showBmi ? 'hideInPrint' : ''}>BMI: {calculateBmi(vitals.weight, vitals.height)} kg/m²</span> <input type="checkbox" onChange={() => setShowBmi(!showBmi)} /></li>
            </ul>}

            </div>

            <div className="thory_panel">
                {toShow.diagnosis && <DiagnosisShow appID={props.appID} />}
                {toShow.investigation && <InvestigationShow appID={props.appID} />}
            </div>
            <div className="medi_panel">
                {toShow.treatment && <TreatmentShow showCarryForward={props.historyPage} appID={props.appID} />}
            </div>

        </div>
        {(toShow.complainst || toShow.examination) && <div className="final_report_wrapper" style={{paddingTop: '10px'}}>
            <div>
            {(toShow.complainst) && <>
                    <h2>Complaints</h2>
                    <ShowLeftEarPain data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.LeftEar && chiefComplain.ChiefComplaints_location.LeftEar} />
                    <ShowLeftEarDischarge data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.LeftEar && chiefComplain.ChiefComplaints_location.LeftEar} />
                    <ShowLeftEarHearingLoss data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.LeftEar && chiefComplain.ChiefComplaints_location.LeftEar} />
                    <ShowLeftEarTinnitis data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.LeftEar && chiefComplain.ChiefComplaints_location.LeftEar} />
                    <ShowLeftEarVertigo data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.LeftEar && chiefComplain.ChiefComplaints_location.LeftEar} />
                    <ShowLeftEarFacialWeakness data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.LeftEar && chiefComplain.ChiefComplaints_location.LeftEar} />

                    <ShowRightEarPain data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.RightEar && chiefComplain.ChiefComplaints_location.RightEar} />
                    <ShowRightEarDischarge data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.RightEar && chiefComplain.ChiefComplaints_location.RightEar} />
                    <ShowRightEarHearingLoss data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.RightEar && chiefComplain.ChiefComplaints_location.RightEar} />
                    <ShowRightEarTinnitis data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.RightEar && chiefComplain.ChiefComplaints_location.RightEar} />
                    <ShowRightEarVertigo data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.RightEar && chiefComplain.ChiefComplaints_location.RightEar} />
                    <ShowRightEarFacialWeakness data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.RightEar && chiefComplain.ChiefComplaints_location.RightEar} />

                    <ShowNasalPain data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.Nasal && chiefComplain.ChiefComplaints_location.Nasal} />
                    <ShowNasalDischarge data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.Nasal && chiefComplain.ChiefComplaints_location.Nasal} />
                    <ShowNasalHistoryOfNasalSymptomsWithComplication data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.Nasal && chiefComplain.ChiefComplaints_location.Nasal} />
                    <ShowNasalObstruction data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.Nasal && chiefComplain.ChiefComplaints_location.Nasal} />
                    
                    <ShowOralCavityUlcer data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.OralCavity && chiefComplain.ChiefComplaints_location.OralCavity} />
                    <ShowOralCavityPain data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.OralCavity && chiefComplain.ChiefComplaints_location.OralCavity} />
                    
                    <ShowThroatLarynxHypopharynxHoarseness data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.ThroatLarynxHypopharynx && chiefComplain.ChiefComplaints_location.ThroatLarynxHypopharynx} />
                    <ShowThroatLarynxHypopharynxBreathingProblem data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.ThroatLarynxHypopharynx && chiefComplain.ChiefComplaints_location.ThroatLarynxHypopharynx} />
                    <ShowThroatLarynxHypopharynxSwallowingProblem data={chiefComplain && chiefComplain.ChiefComplaints_location && chiefComplain.ChiefComplaints_location.ThroatLarynxHypopharynx && chiefComplain.ChiefComplaints_location.ThroatLarynxHypopharynx} />
                </>}
                {toShow.examination && <>
                    <h2>Examination</h2>
                    <ShowLeftEar data={examination && examination.examination_location && examination.examination_location && examination.examination_location} />
                    <ShowRightEar data={examination && examination.examination_location && examination.examination_location && examination.examination_location} />
               
                    <ShowLeftNose data={examination && examination.examination_location && examination.examination_location && examination.examination_location} />
                    <ShowRightNose data={examination && examination.examination_location && examination.examination_location && examination.examination_location} />
               
                    <ShowOralCavityThroat data={examination && examination.examination_location && examination.examination_location && examination.examination_location} />
               
                    <ShowThroatLarynxHypopharynx data={examination && examination.examination_location && examination.examination_location && examination.examination_location} />
               
                    <ShowThyroid data={examination && examination.examination_location && examination.examination_location && examination.examination_location} />
               
                    <ShowNeckMass data={examination && examination.examination_location && examination.examination_location && examination.examination_location} />
               
                    <ShowParotidSybmandibularMass data={examination && examination.examination_location && examination.examination_location && examination.examination_location} />
               
                    <ShowUlcer data={examination && examination.examination_location && examination.examination_location && examination.examination_location} />

                </>}
                </div>
        </div>}
        </>
    );
}

export default FinalReport;
